<template>
  <section id="events-list">
    <h1>EXHIBITIONS</h1>
    
    <OfflineMode />

    <div v-if="fairItems.length && !loadingData && showAlert" class="container text-center my-3">
      <div class="alert alert-info">
        <h4 class="alert-heading">There are no fairs you attend!</h4>
        <hr />
        <p>
          If you should attend a fair and you don't see it, please contact us at
          <a href="mailto:info@coesiaevents.com">info@coesiaevents.com</a>
        </p>
      </div>
      <hr class="my-4">
    </div>

    <div v-if="loadingData" class="container text-center my-3">
      <div class="alert alert-info">
        <h4 class="alert-heading">
          <i class="fas fa-spinner fa-spin me-2"></i>
          Loading data, please wait...
        </h4>
      </div>
    </div>
    
    <div v-if="fairItems" class="container-fluid container-lg">
        
      <div 
        v-for="eventItem in fairItems"
        :key="eventItem.id"
        class="my-4">
        <div :class="['row align-items-center', (eventItem.ongoing) ? '' : 'inactive']" v-if="eventItem" :id="'fair-'+ eventItem.id">
        
          <div class="col-12 col-md-6">
						<img :src="`${publicPath}`+ eventItem.image" v-bind:alt="eventItem.title" class="img-fluid" />
          </div>
          
          <div class="col-12 col-md-6">
            <div class="text-center">
            
              <h2 class="mb-1">{{ eventItem.title }}</h2>
              <h3>{{ eventItem.venue }} - {{ eventItem.country }}</h3>
              <p>{{ eventItem.data }}</p>
              
              <div v-if="user && eventItem.active && !loadingData">

                <div v-html="getPresence(eventItem)"></div>

                <div :id="'buttons-'+ eventItem.id" class="text-center">
                  <router-link v-if="eventItem.published" :id="'profile-'+ eventItem.id" :to="'/events/' + eventItem.id + '/presence'" class="btn btn-secondary mx-3 mb-2 d-none">
                    <i class="fas fa-edit"></i> 
                    Your dates
                  </router-link>
                  <router-link v-if="previewEvent" :id="'details-'+ eventItem.id" :ref="'details-'+ eventItem.id" :to="'/events/' + eventItem.id" class="btn btn-coesia mx-3 mb-2 d-none">
                    <i class="fas fa-long-arrow-alt-right animate"></i>
                    Exhibition details
                  </router-link>
                </div>
              </div>
              
            </div>
          </div>
          
        </div>
        <hr class="my-4">
      </div>

    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import OfflineMode from '../OfflineMode';

export default {
  name: 'EventsList',
  computed: {
    ...mapGetters([
      "loadingData",
      'token',
      "fairItems",
      "contactItems",
      "user",
			"contactType",
      "offlineMode"
    ])
  },
  data () {
    return {
      publicPath: process.env.BASE_URL,
      showAlert: (this.user && this.user.level !== 'user') ? false : true,
      previewEvent: false
    }
  },
  methods: {
    getPresence(fair) {
			let html = ''
			let userState = this.contactType(fair.id, this.user.id)
      let box = document.getElementById('buttons-'+ fair.id)
      let btnProfile = document.getElementById('profile-'+ fair.id)
      let btnDetails = document.getElementById('details-'+ fair.id)
      if (!userState) {
        if (box) box.remove()
        return '';
      }
      // se partecipante o admin ammesso a vedere le pagine
      if (userState.authorized) {
        this.showAlert = false;
        this.previewEvent = true
				// visibilità pubblica durante compilazione
				if (!fair.published && !userState.isstaff && !userState.isadmin) {
          this.previewEvent = false
					html = '<div class="text-center"> \
						<a href="/events/'+ fair.id +'" class="btn btn-coesia mx-3 mb-2 disabled" disabled> \
							<i class="fas fa-hourglass-start animate"></i> \
							Coming soon \
						</a> \
					</div>'
					return html
				}
				// output html
				let strPresence = ''
				// se partecipante o staff recupero le date
				if ((userState.isparticipant || userState.isstaff) && fair.ongoing) {
					//console.log("sono presente - showAlert: "+ this.showAlert +" authorized: "+ userState.authorized)
					var checkinFair = userState.checkinFair;
					var checkoutFair = userState.checkoutFair;
					checkinFair = global.formatDate(checkinFair);
					checkoutFair = global.formatDate(checkoutFair);
					strPresence = "<p> \
						<span class=\"font-bold\">Your presence at fair booth:</span><br>";
					if (checkinFair !== checkoutFair) {
						strPresence += checkinFair +" / "+ checkoutFair;
					} else {
						strPresence += checkinFair;
					}
					strPresence += '</p>'
          if (btnProfile) btnProfile.classList.remove('d-none')
				} else {
          if (btnProfile) btnProfile.remove()
        }
				html = strPresence
        if (btnDetails) btnDetails.classList.remove('d-none')
      }
			return html
    },
  },
  created() {
  },
  components: {
    OfflineMode
  }
}
</script>

<style></style>

<style scoped>
	#events-list .my-4:last-child hr { display: none; }
</style>
